import React from '../files/react-original.svg';
import JavaScript from '../files/javascript-original.svg';
import Bootstrap from '../files/bootstrap-original.svg';
import HTML from '../files/html5-original.svg';
import Sass from '../files/sass-original.svg';
import JQuery from '../files/jquery-original.svg';
import Babel from '../files/babel-original.svg';
import Tailwind from '../files/tailwindcss-original.svg';
import TypeScript from '../files/typescript-original.svg';
import Python from '../files/python-original.svg';
import nodejs from '../files/nodejs-original-wordmark.svg';
import php from '../files/php-original.svg';
import MongoDB from '../files/mongodb-original.svg';
import Express from '../files/express-original.svg';
import Netcore from '../files/dot-net-original.svg';
import MySql from '../files/mysql-original.svg';
import Github from '../files/github.svg';
import Photoshop from '../files/photoshop-original.svg';
import Illustrator from '../files/illustrator-plain.svg';
import VSCode from '../files/vscode.svg';
import Webflow from '../files/webflow-original.svg';
import WordPress from '../files/wordpress-original.svg';
import Apache from '../files/apache-original.svg';



const skillsData = [
  { name: 'React.js', logo: React },
  { name: 'JavaScript', logo: JavaScript },
  { name: 'HTML5', logo: HTML },
  { name: 'Sass', logo: Sass },
  { name: 'JQuery', logo: JQuery },
  { name: 'Bootstrap', logo: Bootstrap },
  { name: 'Babel', logo: Babel },
  { name: 'Tailwind CSS', logo: Tailwind },
  { name: 'TypeScript', logo: TypeScript },
  { name: 'Python', logo: Python },
  { name: 'nodejs', logo: nodejs },
  { name: 'php', logo: php },
  { name: 'MongoDB', logo: MongoDB },
  { name: 'Express', logo: Express },
  { name: '.NET core', logo: Netcore },
  { name: 'MySql', logo: MySql },
  { name: 'Github', logo: Github },
  { name: 'Photoshop', logo: Photoshop },
  { name: 'Illustrator', logo: Illustrator },
  { name: 'VS Code', logo: VSCode },
  { name: 'Webflow', logo: Webflow },
  { name: 'WordPress', logo: WordPress },
  { name: 'Apache', logo: Apache },
];

const Skills = () => {
  return (
    <div className='skills'>
      <h2>Skills</h2>
      <div className="skills-container">
        <div className='skills-section'>
          <h3>Frontend</h3>
          <div className='skills-grid'>
            {skillsData.slice(0, 9).map((skill, index) => (
              <div className='skills-grid-list' key={index}>
                <img src={skill.logo} alt={skill.name} />
                <p>{skill.name}</p>
              </div>
            ))}
          </div>
        </div>
        <div className='skills-section'>
          <h3>Backend</h3>
          <div className='skills-grid'>
            {skillsData.slice(9,16).map((skill, index) => (
              <div className='skills-grid-list' key={index}>
                <img src={skill.logo} alt={skill.name} />
                <p>{skill.name}</p>
              </div>
            ))}
          </div>
        </div>
        <div className='skills-section'>
          <h3>Other</h3>
          <div className='skills-grid'>
            {skillsData.slice(16,23).map((skill, index) => (
              <div className='skills-grid-list' key={index}>
                <img src={skill.logo} alt={skill.name} />
                <p>{skill.name}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="divider"></div>
    </div>
  );
};

export default Skills;